import OCWidgetPage from "./OCWidgetPage";

const DesignEyeQPage = () => (
  <OCWidgetPage
    title="Design EyeQ® Visualizer"
    description="Upload a photo of your home and try on different Owens Corning shingle colors."
    metaDescription="Upload a photo of your home and virtually try on different Owens Corning shingle colors with Design EyeQ."
  >
    <div id="visualizer" data-zip="87101" />
  </OCWidgetPage>
);

export default DesignEyeQPage;
